/* tslint:disable */

/**
 */
export class ChainingStudyEquipment {
    name?: string;
    symbol?: string;
    isChaining?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/chaining-study-equipment.ts